import type { StickySectionEntry } from '#/components/ui/StickySectionNav';
import type { CategoryContentView } from '#/content/category';

/**
 * Build the section-nav entries for the content-driven parts of a category
 * page, in render order, including only the sections that will actually
 * render.
 *
 * The learning entry borrows the section's own heading (e.g. "Selecting an
 * Equity") rather than a generic label, so the nav reads like the page.
 */
export function categoryContentNavSections(
  content: CategoryContentView,
): StickySectionEntry[] {
  const sections: StickySectionEntry[] = [{ id: 'summary', label: 'Summary' }];

  if (content.learning) {
    sections.push({ id: 'learning', label: content.learning.header.title });
  }

  if (content.toolsResources) {
    sections.push({ id: 'tools-resources', label: 'Tools & Resources' });
  }

  return sections;
}
